(() => {
  const setup = (scope = document) => {
    scope.querySelectorAll('.mmhp-page').forEach((page) => {
      if (page.dataset.mmSelectorReady) return;
      const choices = Array.from(page.querySelectorAll('[data-mm-product-choice]'));
      const panels = Array.from(page.querySelectorAll('.mmhp-product'));
      if (!choices.length || !panels.length) return;
      page.dataset.mmSelectorReady = 'true';
      const status = page.querySelector('[data-mm-product-status]');
      const select = (choice, announce = true) => {
        const scrollTop = window.scrollY;
        const scrollLeft = window.scrollX;
        const target = panels.find((panel) => panel.id === choice.hash.slice(1));
        if (!target) return;
        choices.forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
        panels.forEach((panel) => { panel.hidden = panel !== target; });
        if (announce) {
          window.scrollTo({ top: scrollTop, left: scrollLeft, behavior: 'instant' });
        }
        if (announce && status) status.textContent = `${status.dataset.label}: ${choice.dataset.productTitle}`;
      };
      choices.forEach((choice) => {
        choice.setAttribute('role', 'button');
        choice.addEventListener('click', (event) => {
          event.preventDefault();
          choice.focus({ preventScroll: true });
          select(choice);
        });
        choice.addEventListener('keydown', (event) => {
          if (event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            select(choice);
          }
        });
      });
      const fragmentChoice = choices.find((choice) => choice.hash === location.hash);
      const requestedProduct = new URLSearchParams(location.search).get('product');
      const requestedChoice = choices.find((choice) => choice.dataset.productHandle === requestedProduct);
      select(requestedChoice || fragmentChoice || choices[0], false);
      window.addEventListener('hashchange', () => {
        const match = choices.find((choice) => choice.hash === location.hash);
        if (match) select(match);
      });
    });
  };
  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
